import UserList from './user.list';
import UserDetail from './user.detail';
import UserCreate from './user.create';

export const UserStores = {
  list: UserList,
  detail: UserDetail,
  create: UserCreate,
};
